import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const DangerSolidIcon = forwardRef<SVGSVGElement, IconProps>(function DangerSolidIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4139 12.555L11.8966 2.57845C11.1552 1.23612 10.1293 0.5 9 0.5C7.87068 0.5 6.84481 1.23612 6.10343 2.57845L0.586142 12.555C-0.11214 13.8281 -0.189726 15.0492 0.370623 16.0104C0.930972 16.9717 2.03443 17.5 3.48272 17.5H14.5173C15.9656 17.5 17.069 16.9717 17.6294 16.0104C18.1897 15.0492 18.1121 13.8194 17.4139 12.555ZM8.35344 6.56215C8.35344 6.20708 8.64655 5.91263 9 5.91263C9.35345 5.91263 9.64656 6.20708 9.64656 6.56215V10.8923C9.64656 11.2473 9.35345 11.5418 9 11.5418C8.64655 11.5418 8.35344 11.2473 8.35344 10.8923V6.56215ZM9.61207 14.1052C9.56897 14.1398 9.52587 14.1745 9.48276 14.2091C9.43104 14.2438 9.37931 14.2697 9.32759 14.2871C9.27586 14.313 9.22414 14.3304 9.16379 14.339C9.11207 14.3477 9.05172 14.3563 9 14.3563C8.94827 14.3563 8.88793 14.3477 8.82758 14.339C8.77586 14.3304 8.72414 14.313 8.67241 14.2871C8.62069 14.2697 8.56896 14.2438 8.51724 14.2091C8.47413 14.1745 8.43103 14.1398 8.38793 14.1052C8.23275 13.9407 8.13792 13.7155 8.13792 13.4903C8.13792 13.2652 8.23275 13.04 8.38793 12.8754C8.43103 12.8408 8.47413 12.8062 8.51724 12.7715C8.56896 12.7369 8.62069 12.7109 8.67241 12.6936C8.72414 12.6676 8.77586 12.6503 8.82758 12.6416C8.93965 12.6156 9.06034 12.6156 9.16379 12.6416C9.22414 12.6503 9.27586 12.6676 9.32759 12.6936C9.37931 12.7109 9.43104 12.7369 9.48276 12.7715C9.52587 12.8062 9.56897 12.8408 9.61207 12.8754C9.76725 13.04 9.86207 13.2652 9.86207 13.4903C9.86207 13.7155 9.76725 13.9407 9.61207 14.1052Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
